import { useEffect, useState } from 'react';
import { APP_NAME } from '../config';

/** Đồng hồ cập nhật theo chu kỳ (đếm ngược giữ căn, "x phút trước"). */
export function useNow(ms = 1000) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), ms);
    return () => clearInterval(t);
  }, [ms]);
  return now;
}

/** Giá trị trễ `ms` sau lần đổi cuối (kiểm trùng SĐT, Tìm nhanh, xem trước nhập file). */
export function useDebounced<T>(value: T, ms = 200) {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return v;
}

/**
 * Tiêu đề tab trình duyệt / mục lịch sử / thông báo trang của trình đọc màn hình (WCAG 2.4.2): `title` (vắng ⇒ tên ứng
 * dụng); gỡ ⇒ trả về tên ứng dụng.
 */
export function useDocumentTitle(title: string | null | undefined) {
  useEffect(() => {
    document.title = title || APP_NAME;
  }, [title]);
  useEffect(
    () => () => {
      document.title = APP_NAME;
    },
    [],
  );
}

/** localStorage an toàn (chế độ riêng tư / bị chặn ⇒ dùng giá trị mặc định). */
export function useStoredState<T>(key: string, initial: T) {
  const [v, setV] = useState<T>(() => {
    try {
      const raw = localStorage.getItem(key);
      return raw == null ? initial : (JSON.parse(raw) as T);
    } catch {
      return initial;
    }
  });
  const set = (next: T) => {
    setV(next);
    try {
      localStorage.setItem(key, JSON.stringify(next));
    } catch {
      /* bỏ qua */
    }
  };
  return [v, set] as const;
}

export async function copyText(text: string) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
